import { getTrackFunc, trackConfig } from '@/framework';
import { Layer } from '@/layers/layer';
import { LayerType, type IQrCodeInfo } from '@/version-types';
import { getAddLayerSize } from './utils/add-layer';
import { setContent, setStyle } from './utils/att-operate';
import { getQrCodeLayerProps } from './utils/converter';

export class QRCodeLayer extends Layer {
    constructor(identity: string) {
        super(identity);
    }

    /**
     * 根据信息添加二维码图层
     */
    addByInfo(info: IQrCodeInfo, options?: { trackProps?: string }) {
        const { framework } = this;
        const stageIndex = framework.service.frame.getActiveIndex();
        const stageSize = framework.service.frame.getSizeByIndex(stageIndex);

        const layerSize = getAddLayerSize(stageSize);
        const layer = getQrCodeLayerProps(layerSize, info);
        const { trackProps } = options || {};
        const trackFunc = trackProps ? getTrackFunc(this.identity, layer, trackProps) : undefined;

        return this.addByDiagonal({
            layer,
            trackFunc,
        });
    }

    /**
     * 更新二维码图层内容
     */
    updateContent(
        id: string,
        content: { official: string; text: string },
        options?: { trackProps?: string; writeHistory?: boolean },
    ) {
        const { trackProps, writeHistory } = options || {};

        const oldLayer = this.framework.service.flatLayer.getLayer(id, true);
        if (!oldLayer) return;

        const newLayer = this.framework.service.flatLayer.getLayer(id, true);
        setContent(newLayer, content);
        this.framework.service.frame.addOrUpdateLayer(newLayer);

        if (writeHistory) {
            const trackFunc = trackProps ? getTrackFunc(this.identity, newLayer, trackProps) : undefined;
            this.framework.service.history.write(oldLayer, trackFunc);
        }
    }

    /**
     * 更新二维码图层样式
     * HACK: 这里的 stroke 只允许写入 string 的格式，大概是因为外出更新的场景都是从颜色选择器取的 string 格式，包括渐变的场景
     */
    updateStyle(
        id: string,
        style: { fill?: string; stroke?: string },
        options?: { writeHistory?: boolean; oldStyle?: { fill?: string; stroke?: string } },
    ) {
        if (typeof style.fill !== 'string' && typeof style.stroke !== 'string') {
            return;
        }
        const { writeHistory, oldStyle } = options || {};

        const newLayer = this.framework.service.flatLayer.getLayer(id, true);
        if (!newLayer) return;
        setStyle(newLayer, style);
        this.framework.service.frame.addOrUpdateLayer(newLayer);

        if (writeHistory && oldStyle) {
            const oldLayer = this.framework.service.flatLayer.getLayer(id, true);
            setStyle(oldLayer, oldStyle);
            this.framework.service.history.write(oldLayer, trackConfig[LayerType.QR_CODE].style);
        }
    }
}
